import axios from "axios";
import { IS_ATT_HOST } from "@/lib/attHost";

// On the dedicated attendance domain the API is same-origin (first-party cookies); elsewhere use the configured backend.
export const API = `${IS_ATT_HOST ? window.location.origin : process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "919162055572";
let waNumber = WHATSAPP_NUMBER;
export const setWhatsAppNumber = (n) => { if (n) waNumber = String(n).replace(/\D/g, ""); };
export const waLink = (message) =>
  `https://wa.me/${waNumber}?text=${encodeURIComponent(message)}`;

export function getVisitorId() {
  let id = localStorage.getItem("mf_visitor_id");
  if (!id) {
    id = `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("mf_visitor_id", id);
  }
  return id;
}

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function captureUTM() {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v;
  });
  if (Object.keys(found).length > 0) {
    sessionStorage.setItem("mf_utm", JSON.stringify(found));
  }
}

export function getUTM() {
  try {
    return JSON.parse(sessionStorage.getItem("mf_utm") || "{}");
  } catch {
    return {};
  }
}

export function track(event, meta = {}) {
  api
    .post("/events", {
      event,
      page: window.location.pathname,
      visitor_id: getVisitorId(),
      utm: getUTM(),
      meta,
    })
    .catch(() => {});
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
